import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import HeaderNavbar from "../Component/Navbar";
import Footer from "../Component/Footer";
import mrg from "../assets/marriage.jpeg";

export default function Privacy() {
  return (
    <>
      <HeaderNavbar />

      {/* PAGE HEADER */}
      <div
        style={{
          background: "#f8f5f2",
          padding: "60px 0",
          textAlign: "center",
        }}
      >
        <h1 style={{ color: "#7b1e3b", fontWeight: "600" }}>Privacy Policy</h1>


      </div>

      {/* TERMS SECTION */}
      <Container style={{ padding: "70px 10px" }}>
        <Row>
          <Col lg={12}>
            <h3 className="mb-3">1. Purpose</h3>
            <p>
              This Privacy, Data Processing & DPDP Compliance Policy explains how KVL Matrimony a Platform, through their website https://kvlmatrimony.com, collects, uses, stores, shares, protects and processes personal information in accordance with the Digital Personal Data Protection Act, 2023 (DPDP Act) and other applicable laws.<br />
              By registering or using the Platform, you consent to the practices described in this Policy.

            </p>
            <h3 className="mt-5 mb-3">2. Scope</h3>
            <p>This Policy applies to:<br />
              •	Website visitors<br />
              •	Registered members<br />
              •	Premium subscribers<br />
              •	Prospective users<br />
              •	Customer support interactions<br />

            </p>
            <h3 className="mt-5 mb-3">3. Information We Collect</h3>
            <p>We may collect the following information:<br />
              Personal Information<br />
              •	Name<br />
              •	Date of Birth<br />
              •	Gender<br />
              •	Marital Status<br />
              •	Occupation<br />
              •	Education<br />
              •	Contact Number<br />
              •	Email Address<br />
              •	Place of Residence<br />
              Community Information<br />
              •	Veerashaiva Lingayat Sub-sect<br />
              •	Gothra (if voluntarily provided)<br />
              •	Family Details<br />
              •	Lifestyle Preferences<br />
              Profile Information<br />
              •	Photographs<br />
              •	Personal Description<br />
              •	Partner Preferences<br />
              •	Interests<br />
              •	Horoscope details (where provided)<br />
              Technical Information<br />
              •	IP Address<br />
              •	Device Information<br />
              •	Browser Information<br />
              •	Login History<br />
              •	Cookies<br />
              •	Usage Analytics<br />
              Payment Information<br />
              Subscription payments are processed through authorized payment service providers. KVL Matrimony does not store complete card or banking credentials.
            </p>

            <h3 className="mt-5 mb-3">4. Purpose of Processing</h3>
            <p>
              Your information is processed to:<br />
              •	Create and manage your account.<br />
              •	Display your matrimonial profile.<br />
              •	Facilitate member interactions.<br />
              •	Verify profile information.<br />
              •	Process subscriptions.<br />
              •	Provide customer support.<br />
              •	Improve Platform performance.<br />
              •	Prevent fraud and misuse.<br />
              •	Comply with legal obligations.

            </p>

            <h3 className="mt-5 mb-3">5. User Consent</h3>
            <p>
              By creating an account or using the Platform, you consent to:<br />
              •	Collection of your personal information.<br />
              •	Processing of your information for matrimonial services.<br />
              •	Display of your profile to eligible members.<br />
              •	Receiving service-related communications.<br />
              •	Processing in accordance with applicable laws.<br />
              You may withdraw your consent at any time, subject to legal and contractual obligations.

            </p>

            <h3 className="mt-5 mb-3">6. Your Rights</h3>
            <p>
              Subject to applicable law, you have the right to:<br />
              •	Access your personal information.<br />
              •	Correct inaccurate information.<br />
              •	Update your profile.<br />
              •	Withdraw consent.<br />
              •	Request deletion of your account.<br />
              •	Raise privacy-related grievances.<br />
              Requests shall be processed within reasonable timelines, subject to legal requirements.

            </p>

            <h3 className="mt-5 mb-3">7. Profile Visibility</h3>
            <p>
              Information shared on your profile is visible only in accordance with your selected privacy settings and membership features.<br />
              Certain profile details may remain hidden unless you choose to disclose them.

            </p>

            <h3 className="mt-5 mb-3">8. Data Sharing</h3>
            <p>Your information may be shared only when necessary with:<br />
              •	Payment service providers<br />
              •	Cloud hosting providers<br />
              •	SMS service providers<br />
              •	Email service providers<br />
              •	Identity verification partners<br />
              •	Technology service providers<br />
              •	Government or regulatory authorities when legally required<br />
              KVL Matrimony does not sell or rent personal information to third parties.

            </p>
            <h3 className="mt-5 mb-3">9. Cookies & Analytics</h3>
            <p>
              The Platform uses cookies and similar technologies to:<br />
              •	Maintain user sessions<br />
              •	Improve user experience<br />
              •	Remember preferences<br />
              •	Measure website performance<br />
              •	Enhance security<br />
              Users may control cookie preferences through their browser settings. Certain features may not function correctly if cookies are disabled.

            </p>

            <h3 className="mt-5 mb-3">10. Data Security</h3>
            <p>
              KVL Matrimony implements reasonable administrative, technical and organizational safeguards to protect personal information against unauthorized access, alteration, disclosure, misuse or loss.<br />
              While every reasonable effort is made to secure user data, no internet-based system can guarantee absolute security.


            </p>

            <h3 className="mt-5 mb-3">11. Data Retention</h3>
            <p>
              Personal information shall be retained only for as long as:<br />
              •	Your account remains active;<br />
              •	It is necessary to provide services;<br />
              •	Required by applicable law; or<br />
              •	Needed for dispute resolution or legal compliance.<br />
              Data that is no longer required shall be securely deleted or anonymized.


            </p>

            <h3 className="mt-5 mb-3">12. Account Deletion</h3>
            <p>
              Users may request deletion of their account at any time.<br />
              Upon approval, personal information shall be removed or anonymized, except where retention is required by law or for legitimate business purposes.<br />
              Subscription fees already paid shall be governed by the Subscription Policy.

            </p>

            <h3 className="mt-5 mb-3">13. Cross-Border Processing</h3>
            <p>
              Where technology infrastructure or service providers operate outside India, personal information may be processed in accordance with applicable legal requirements and adequate security measures.

            </p>

            <h3 className="mt-5 mb-3>">14. Third-Party Services</h3>
            <p>The Platform may use trusted third-party providers for:<br />
              •	Payment processing<br />
              •	Cloud hosting<br />
              •	Communication services<br />
              •	Analytics<br />
              •	Security monitoring<br />
              •	Identity verification<br />
              Each provider processes information only for authorized purposes and is expected to maintain appropriate security standards.
            </p>

            <h3 className="mt-5 mb-3>">15. Data Breach Response</h3>
            <p>In the event of a suspected or confirmed personal data breach, KVL Matrimony shall take appropriate measures to:<br />
              •	Assess the impact.<br />
              •	Contain the incident.<br />
              •	Restore service where applicable.<br />
              •	Notify affected users or competent authorities where required by law.

            </p>

            <h3 className="mt-5 mb-3>">16. Children's Privacy</h3>
            <p>The Platform is intended only for individuals legally eligible for marriage.<br />
              KVL Matrimony does not knowingly collect personal information from minors.

            </p>

            <h3 className="mt-5 mb-3>">17. User Responsibilities</h3>
            <p>Users shall:<br />
              •	Provide accurate information.<br />
              •	Update profile information when required.<br />
              •	Protect account credentials.<br />
              •	Avoid sharing confidential information unnecessarily.<br />
              •	Respect the privacy of other members.<br />
              •	Use information obtained through the Platform solely for lawful matrimonial purposes.

            </p>

            <h3 className="mt-5 mb-3>">18. Compliance</h3>
            <p>KVL Matrimony processes personal information in accordance with applicable laws, including:<br />
              •	Digital Personal Data Protection Act, 2023<br />
              •	Information Technology Act, 2000<br />
              •	Applicable Rules and Notifications issued thereunder<br />
              •	Other applicable statutory and regulatory requirements

            </p>

            <h3 className="mt-5 mb-3>">19. Grievance Officer</h3>
            <p>Users may submit privacy-related requests, complaints or grievances to the designated Grievance Officer through the contact details published on the Platform / website (https://kvlmatrimony.com).<br />
              Reasonable efforts shall be made to acknowledge and resolve grievances within the timelines prescribed under applicable law.

            </p>

            <h3 className="mt-5 mb-3>">20. Policy Updates</h3>
            <p>KVL Matrimony may update this Policy from time to time.<br />
              The latest version shall always be available on the Platform.<br />
              Continued use of the Platform after publication of revised terms constitutes acceptance of the updated Policy.

            </p>

            <h3 className="mt-5 mb-3>">21. User Declaration</h3>
            <p>By registering or using KVL Matrimony, you acknowledge that:<br />
              •	You have read and understood this Privacy Policy.<br />
              •	You consent to the collection and processing of your personal information.<br />
              •	The information provided by you is accurate.<br />
              •	You understand your rights regarding your personal data.<br />
              •	You agree to the processing of your information for the purposes described in this Policy.

            </p>



            <p className="mt-5 text-muted">
              <strong>Last Updated:</strong>5th, July 2026
            </p>
          </Col>
        </Row>
      </Container>





      <Footer />
    </>
  );
}
